// CSS imports - loaded first for proper order
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
import '@vuepic/vue-datepicker/dist/main.css'

// Vue core
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// External libraries
import 'bootstrap'
import { createBootstrap } from 'bootstrap-vue-next'
import VueDatePicker from '@vuepic/vue-datepicker'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// Custom plugins
import './plugins/font-awesome'
import './plugins/tippy-js'
import './plugins/dayjs'
import vueMqPlugin from './plugins/vue-mq'
import { setupValidation } from './plugins/validation'

const app = createApp(App)

// Setup plugins
app.use(router)
app.use(createBootstrap())
vueMqPlugin(app)
setupValidation(app)

// Register global components
app.component('VueDatePicker', VueDatePicker)
app.component('FontAwesomeIcon', FontAwesomeIcon)

app.mount('#app')
